// @flow

export class ApiError extends Error {
  response: string;

  constructor(response: string) {
    super();
    this.name = 'ApiError';
    this.response = response;
  }
}
